<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="top">
                <img src="@/assets/multiply.png" @click="close" />
                <h4>
                  Library
                </h4>
              </div>
              <div class="modal-body">
                <table>
                  <tbody>
                    <tr
                      v-for="item in items"
                      :key="item.id"
                      @click="getItem(item)"
                    >
                      <td id="avatar">Y</td>
                      <td id="text">{{ item.name }}</td>
                      <td id="selector"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getItem(item) {
      this.$emit("selectedItem", item);
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-content {
  border-radius: 0;
  height: 400px;
  width: 600px;
}
.top {
  margin-bottom: 64px;
}
.top img {
  float: left;
  padding: 33px 0px 0px 34px;
}
.top h4 {
  text-align: center;
  margin-top: 54px;
  color: #37383b;
  font-size: 23px;
  font-weight: bold;
}
.modal-body {
  padding-left: 140px;
  padding-right: 140px;
  margin-bottom: 64px;
  overflow: scroll;
}
table tbody tr:nth-child(1) {
  border-top: 1px solid silver;
}
table tbody tr #avatar {
  width: 43px;
  color: #ffffff;
  background: #9da2a6;
}
table tbody tr #text {
  text-align: left;
}
@media (max-width: 768px) {
  .modal-content {
    height: 400px;
    width: 100%;
  }
  .modal-body {
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 30px;
  }
}
</style>
